
import * as AWSServerlessImageHandlerRuntime$vYtMG5Cqaq from '/app/app/providers/AWSServerlessImageHandlerProvider/index.ts'
import * as ipxRuntime$m44AN8elwM from '/app/node_modules/.pnpm/@nuxt+image@1.8.1_db0@0.2.4_ioredis@5.5.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "xxxl": 1920,
    "3xl": 1920
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "imagens.pilarhomes.com.br",
    "pilarhomes.com.br"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['AWSServerlessImageHandler']: { provider: AWSServerlessImageHandlerRuntime$vYtMG5Cqaq, defaults: {"baseUrl":"https://imagens.pilarhomes.com.br"} },
  ['ipx']: { provider: ipxRuntime$m44AN8elwM, defaults: {} }
}
        